import { render, staticRenderFns } from "./offerItem.vue?vue&type=template&id=545f81dc"
import script from "./offerItem.vue?vue&type=script&lang=js"
export * from "./offerItem.vue?vue&type=script&lang=js"
import style0 from "./offerItem.vue?vue&type=style&index=0&id=545f81dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports